import React from 'react';
import PropTypes from 'prop-types';

import BundleProductCard from 'Features/Bundle/components/Cards/BundleProductCard';

export default function FourCardRow({
  filteredBundleTier,
  switchCarouselGame,
  bundleSlug,
}) {
  return (
    <React.Fragment>
      {filteredBundleTier.map((product, i) => {
        const index = i + 1;
        return (
          <div className="four-column-row" key={product._id + index}>
            <BundleProductCard
              product={product}
              switchCarouselGame={switchCarouselGame}
              bundleSlug={bundleSlug}
            />
          </div>
        );
      })}
    </React.Fragment>
  );
}

FourCardRow.propTypes = {
  filteredBundleTier: PropTypes.arrayOf(PropTypes.shape({})),
  switchCarouselGame: PropTypes.func,
  bundleSlug: PropTypes.string,
};

FourCardRow.defaultProps = {
  filteredBundleTier: [],
  switchCarouselGame: () => { },
  bundleSlug: '',
};
